// extracted by mini-css-extract-plugin
export default {"leftSideBar":"Layout_leftSideBar__Vw5j+","topBar":"Layout_topBar__tpTcy","mainContent":"Layout_mainContent__Bq4qw","mainContentBackground":"Layout_mainContentBackground__4dxYV"};